export enum ColorCodes {
  TURQUOISE_GREEN = '#18A395',
  MEDIUM_AQUAMARINE = '#58c3b8',
  LIGHT_TURQUOISE = '#d9f4f1',
  DARK_GRAY = '#434C54',
  ANTI_FLASH_WHITE = '#F0F1F2',
  BLACK = '#000000',
  SILVER_SAND_GREY = '#BBC0C1',
  PASTEL_BLUE = '#AED2CE',
  DARK_BLUE = '#25303E',
  DARK_NAVY_BLUE = '#0C1521',
  LIGHT_GRAY = '#BEBEC4',
}
